import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { browsingDomainStore } from '../../store';
export const getScreenById = (id) => getFetchedDataPayload(browsingDomainStore.data.screensById[id]);
